import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { CommunityMemberPermissions } from './services/community'

export type User = {
  id: string
  token: string
  authorities: string[]
  name: string
  email: string
  ucode: string
  socialName?: string
  avatar?: string
  permissions?: CommunityMemberPermissions
  authStatus?: AuthStatus
}

export type ViewAsDataProps = {
  from: ViewAsFromPageType
  isEnabled: boolean
  role: RoleType
  classItem?: ClassItemType
  isReadonly?: boolean
}

type ClassItemType = {
  hash: string
  defaultClass: boolean
  name?: string
}

enum ViewAsFromPageType {
  Home = 'HomePage',
  EditProduct = 'EditProductPage',
  ListProducts = 'ListProductsPage'
}

export enum RoleType {
  Creator = 'Creator',
  Member = 'Member',
  UserNoAccess = 'UserNoAccess',
  UserLogout = 'UserLogout'
}

/**
 * @user this prop should always be received, it's optional here just to allow us to run the microfront without the shell
 */

export type CommunitySlugMap = {
  id: number
  slug?: string
}

export type AppProps = {
  children?: React.ReactNode
}

export type PathParams = {
  lang: string
  membership: string
}
